import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
const propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
}

function Radio(props) {
  const { children, className, label, onChange, name, checked, disabled, value, ...restProps } = props

  return (
    <div className={cx('radio', className)} {...restProps}>
      <label className={cx('radio-wrapper')}>
        <input className={cx('radio-input')} type='radio' onChange={onChange} name={name} value={value} checked={checked} disabled={disabled} />
        <div className={cx('radio-circle')}>
          <div className={cx('radio-circle-icon', { 'radio-circle-icon--disabled': disabled })} data-is-checked={checked} />
        </div>
        <div className={cx('radio-label')} data-is-checked={checked}>
          {label}
        </div>
      </label>
      {checked && children && children}
    </div>
  )
}

Radio.propTypes = propTypes

export default Radio
